/*
 * This is the SEO component. It is responsible for adding the page's title, description, pathname, thumbnail image to the <head>.
 * It also creates twitter and facebook social cards using the page's metadata.
 * It uses the data located in each page's metadata.mdx file.
 */

import * as React from 'react';
// eslint-disable-next-line import/no-unresolved
import { useLocation } from '@reach/router';
import { getSrc } from 'gatsby-plugin-image';

import useSiteMetadata from '../../hooks/useSiteMetadata';
import wwwApconCom from '../../www.apcon.com';

export default function SEO(props) {
  const { title, description, pathname, thumbnail, noIndex, children } = props;

  const { href } = useLocation();

  // Get the default site info declared in the siteMetadata field of gatsby-config.js
  const {
    siteTitle,
    siteTitleDefault,
    siteUrl,
    siteDescriptionDefault,
    siteImageDefault,
    twitter,
  } = useSiteMetadata();

  // Create an seo data object using the props or default site info if a prop isn't declared
  const seo = {
    title: `${title || siteTitleDefault} | ${siteTitle}`,
    description: description || siteDescriptionDefault,
    url: pathname ? `${siteUrl}${pathname}` : href,
    image: thumbnail || siteImageDefault,
  };

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={getSrc(seo.image)} />
      <link rel="canonical" href={seo.url} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={getSrc(seo.image)} />
      <meta property="og:type" content="website" />
      <meta property="og:see_also" content={wwwApconCom.social.linkedin} />
      <meta property="og:see_also" content={wwwApconCom.social.twitter} />
      <meta property="og:see_also" content={wwwApconCom.social.facebook} />
      <meta property="og:see_also" content={wwwApconCom.social.youtube} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={getSrc(seo.image)} />
      <meta name="twitter:creator" content={twitter} />
      <meta name="creator" content="APCON, Inc." />
      <meta
        name="facebook-domain-verification"
        content="29r5jur9nnp42ds7xn0qzpqb5vz7qe"
      />
      <meta
        name="google-site-verification"
        content="kZk32YIRpdkbjWpmmFZWO52OFSHVt5KRaoUV_DzhJLk"
      />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {noIndex && <meta name="googlebot" content="noindex, nofollow" />}
      {children}
    </>
  );
}
